/* global ga */
/* global gtag */

const EVENT_ACTIONS = {
  click: 'click',
  scroll: 'scroll',
  view: 'view'
};

function trigger(object) {
  if (typeof ga !== 'undefined') {
    ga('send', {
      hitType: 'event',
      eventCategory: object.eventCategory,
      eventAction: object.eventAction,
      eventLabel: object.eventLabel
    });
    gtag_report_conversion(object.eventLabel, object.sendTo);
  }
}

function gtag_report_conversion(url, sendTo) {
  if (!sendTo) return false;

  var callback = function() {
    //   if (typeof(url) != 'undefined') {
    //     window.location = url;
    //   }
  };
  gtag('event', 'conversion', {
    send_to: sendTo,
    event_callback: callback
  });
  return false;
}

function triggerFromSignUp(location) {
  let params = {
    sendTo: process.env.GTAG_SIGN_UP,
    event: 'SignUpEvent',
    eventCategory: 'SignUp Button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromInquilinosVip(location) {
  let params = {
    sendTo: process.env.GTAG_INQUILINO_VIP,
    event: 'InquilinosVipEvent',
    eventCategory: 'Inquilino VIP Button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromOnboarding(location) {
  let params = {
    sendTo: process.env.GTAG_ONBOARDING,
    event: 'OnboardingEvent',
    eventCategory: 'Registration Onboarding Button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromLogin(location) {
  let params = {
    sendTo: process.env.GTAG_LOGIN,
    event: 'LoginEvent',
    eventCategory: 'Sign in button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromCampaign(location) {
  let params = {
    sendTo: process.env.GTAG_CAMPAIGN_REGISTRATION,
    event: 'CampaignRegistration',
    eventCategory: 'Sign up button',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromNoDepositVisit(location) {
  let params = {
    sendTo: process.env.GTAG_ND_VISIT,
    event: 'NoDepositVisit',
    eventCategory: 'Vista',
    eventAction: EVENT_ACTIONS.view,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromNoDepositRegister(location) {
  let params = {
    sendTo: process.env.GTAG_ND_REGISTER,
    event: 'NoDepositRegister',
    eventCategory: 'Registro',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromNoDepositShowAllHomes(location) {
  let params = {
    sendTo: process.env.GTAG_ND_SHOW_ALL_HOMES,
    event: 'NoDepositShowAllHomes',
    eventCategory: 'Clic Inmuebles',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromSignUpOwnerVisit(location) {
  let params = {
    sendTo: process.env.GTAG_SIGN_UP_OWNER_VISIT,
    event: 'SignUpOwnerVisit',
    eventCategory: 'Vista Registro Owner',
    eventAction: EVENT_ACTIONS.view,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromSignUpOwner(location) {
  let params = {
    sendTo: process.env.GTAG_SIGN_UP_OWNER,
    event: 'SignUpOwner',
    eventCategory: 'Registro Owner',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromPricingToolVisit(location) {
  let params = {
    sendTo: process.env.GTAG_PRINCING_TOOL_VISIT,
    event: 'PricingToolVisit',
    eventCategory: 'Pricing Tool - Página vista',
    eventAction: EVENT_ACTIONS.view,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromPricingToolHomeFormSubmit(location) {
  let params = {
    sendTo: process.env.GTAG_PRINCING_TOOL_HOME_FORM_SUBMIT,
    event: 'PricingToolHomeFormSubmit',
    eventCategory: 'Clic en botón "Siguiente"',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromPricingToolGetRecommendedPrice(location) {
  let params = {
    sendTo: process.env.GTAG_PRINCING_TOOL_GET_RECOMMENDED_PRICE,
    event: 'GetRecommendedPrice',
    eventCategory: 'Clic en botón "Calcular precio de renta"',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromPricingToolPublicHome(location) {
  let params = {
    sendTo: process.env.GTAG_PRINCING_TOOL_PUBLIC_HOME,
    event: 'PricingToolPublicHome',
    eventCategory: 'Clic en botón "Poner en Renta mi Inmueble"',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromPricingToolCalculateHome(location) {
  let params = {
    sendTo: process.env.GTAG_PRINCING_TOOL_CALCULATE_HOME,
    event: 'PricingToolCalculateHome',
    eventCategory: 'Clic "Calcular precio"',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromPricingToolCalculateOtherHome(location) {
  let params = {
    sendTo: process.env.GTAG_PRINCING_TOOL_CALCULATE_OTHER_HOME,
    event: 'PricingToolCalculateOtherHome',
    eventCategory: 'Clic en "Calcular otro inmueble"',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

function triggerFromPricingToolGenerateProfit(location) {
  let params = {
    sendTo: process.env.GTAG_PRINCING_TOOL_GENERATE_PROFIT,
    event: 'PricingToolGenerateProfit',
    eventCategory: 'Clic en "Generar ganacias"',
    eventAction: EVENT_ACTIONS.click,
    eventLabel: location
  };

  this.trigger(params);
}

export default {
  methods: {
    trigger,
    triggerFromInquilinosVip,
    triggerFromOnboarding,
    triggerFromSignUp,
    triggerFromLogin,
    triggerFromCampaign,
    triggerFromNoDepositVisit,
    triggerFromNoDepositRegister,
    triggerFromNoDepositShowAllHomes,
    triggerFromSignUpOwnerVisit,
    triggerFromSignUpOwner,
    triggerFromPricingToolVisit,
    triggerFromPricingToolHomeFormSubmit,
    triggerFromPricingToolGetRecommendedPrice,
    triggerFromPricingToolPublicHome,
    triggerFromPricingToolCalculateHome,
    triggerFromPricingToolCalculateOtherHome,
    triggerFromPricingToolGenerateProfit
  }
};
